import * as React from 'react';
import { ApolloProvider as TheApolloProvider } from '@apollo/client';
import client from 'lib/apollo/client';

export default function ApolloProvider({
    children,
}: React.PropsWithChildren<unknown>) {
    return <TheApolloProvider client={client}>{children}</TheApolloProvider>;
}
